import {Component, OnInit, OnDestroy, Input, TemplateRef, ViewChild} from '@angular/core';
import {ApiService} from '../../shared/services/api.service';
import {InternalService} from '../../shared/services/internal.service';
import {NgxImageCompressService} from 'ngx-image-compress';
import {ToastrService} from 'ngx-toastr';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ImageCroppedEvent} from 'ngx-image-cropper';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-form',
  templateUrl: 'form.component.html',
  styleUrls: ['form.component.css']
})
export class FormComponent implements OnInit {
  private modalContext: string;
  @ViewChild('modal') modalContent: TemplateRef<any>;

  @ViewChild('img') imageModal: TemplateRef<any>;

  constructor(public apiService: ApiService,
              private imageCompress: NgxImageCompressService,
              public toastr: ToastrService,
              public translate:TranslateService,
              private ngbModal: NgbModal,
              public internalService: InternalService) {
  }
disable:any =false;
  provinces: any = [];
  province: any;
  cities: any = [];
  city: any;
  listData: any;
  selectValues = {
    select1: '',
    select2: '',
  };
  lisence: any;
  nationalCard: any;
  profileImage: any;
  name: any;
  lastName: any;
  phoneNumber: any;
  nationalCardId: any;
  tags: any = [];
  tagsList: any = [];
  apiStatus;
sendRequestFlag: boolean= false;

  // -------------------Image----------------
  file: any;
  localUrl: any;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;
  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;

  imageChangedEvent: any;
  croppedImage: any;
  Width: any;
  Height: any;
  key: any;
  isShow: any = false;

  ngOnInit() {
    document.querySelector('#nav').scrollIntoView({behavior: 'smooth', block: 'start'});
    this.getProvinces();
    this.getCategories();
  }

  getProvinces() {
    this.apiService.GetProvinces(1).subscribe((response: any) => {
      this.provinces = response.res;
// console.log(this.provinces)
    });
  }

  getCities() {

    this.apiService.getCities(this.province).subscribe((response: any) => {

      this.cities = response.res;
      // console.log(this.cities);
    });
  }

  getCategories() {
    this.apiService.getCategories().subscribe((response: any) => {
      // console.log(response);
      this.listData = {
        result: response.res,
        error: '',
        status: true
      };
    });
  }

  resetSelectValue(id) {
    this.selectValues[id] = '';
    this.internalService.key = 0;
  }

  deleteImage(elementKey) {
    if (elementKey === `profileImage`) {
      this.profileImage = ``;
    } else if (elementKey === `lisence`) {
      this.lisence = ``;
    } else {
      this.nationalCard = ``;
    }
    document.getElementById(elementKey + `Box`).style.display = 'block';
    document.getElementById(elementKey + `Del`).style.display = 'none';
    document.getElementById(elementKey + `Content`).innerHTML = ``;
  }

  sumbit() {
    if (!this.phoneNumber || !this.name || !this.nationalCardId || !this.province || !this.city|| !this.lastName || !this.internalService.key || this.tags.length === 0 || !this.profileImage || !this.nationalCard || !this.lisence) {
      this.translate.get('PleaseFillAllRequiredFiled').subscribe(res=>{
        this.toastr.error(res);
      })
      return false;
    }
    if (!this.validatePhoneNumber(this.phoneNumber)) {
      this.toastr.error('شماره تماس صحیح را وارد کنید');
      return false;
    }
    if (!this.nationalIDValidation(this.nationalCardId)) {
      this.toastr.error('کد ملی صحیح را وارد کنید');
      return false;

    }
    const tagsId = [];
    for (let item of this.tags) {
      tagsId.push(item.id);
    }

    const body = {
      Name: this.name,
      Family: this.lastName,
      phoneNumber: this.phoneNumber,
      IdCardNumber: this.nationalCardId,
      categoryId: this.internalService.key,
      tags: tagsId,
      ProfilePhoto: this.profileImage,
      IdCardPhoto: this.nationalCard,
      CertificatePhotos: [
        {
          photo: this.lisence,
          Type: 13
        }
      ],
      cityId:Number(this.city),
      // province:Number(this.province)
    };
    // console.log(body);

    this.sendRequestFlag= true;
    this.apiService.techPreRegister(body).subscribe((res: any) => {
       // console.log(res);
      if (res.stu === 1) {
        this.showSuccessResult(res.msg);
      } else {
        this.sendRequestFlag= false;
        this.modalContext = res.msg;
        this.apiStatus = res.stu;
        this.ngbModal.open(this.modalContent);
      }

    });


  }

  showSuccessResult(message) {
    this.disable=true;
    // const name = document.getElementById('name') as HTMLInputElement;
    // name.disabled = true;
    // const lastName = document.getElementById('lastName') as HTMLInputElement;
    // lastName.disabled = true;
    // const phoneNumber = document.getElementById('phoneNumber') as HTMLInputElement;
    // phoneNumber.disabled = true;
    const nestedSelect = document.getElementById('nestedSelect') as HTMLInputElement;
    nestedSelect.disabled = true;

    const tags = document.getElementById('tags') as HTMLElement;
    tags.style.visibility = 'hidden';
    const submit = document.getElementById('submit') as HTMLElement;
    submit.innerHTML = `<h4 style="color:#34a853;padding: 5px 3px;background: #cfe2cf;border: 1px solid #34a853; margin: auto; text-align: center;border-radius: 12px;">${message}</h4>`;
    document.getElementById('profileImageDel').style.visibility = 'hidden';
    document.getElementById('nationalCardDel').style.visibility = 'hidden';
    document.getElementById('lisenceDel').style.visibility = 'hidden';
    // const nationalCardId = document.getElementById('nationalCardId') as HTMLInputElement;
    // nationalCardId.disabled = true;
    this.isShow = true;
  }

  validatePhoneNumber(phoneNumber) {
    return phoneNumber.match('^(\\+98|0)?9\\d{9}$');
    // return phoneNumber.match(/^\d{10}$/g);
  }

  nationalIDValidation(id) {

    return id.match('(?<!\\d)\\d{10}(?!\\d)');
  }

  getTags() {
    this.apiService.getTags(this.internalService.key).subscribe((response: any) => {
      // console.log(response);
      this.tagsList = response.res;
    });
  }

  selectFile(event: any, elementKey) {

    let fileName: any;
    this.file = event.target.files[0];
    fileName = this.file.name;
    // console.log(this.file.type);

    if (this.validateFileType(this.file.type)) {
      if (event.target.files && event.target.files[0]) {
        let reader = new FileReader();
        reader.onload = (event: any) => {
          this.localUrl = event.target.result;

          this.compressFile(this.localUrl, fileName, elementKey);
        };
        reader.readAsDataURL(event.target.files[0]);
      }
    }


  }

  open(content, size) { // open modal in large size
    this.fileChangeEvent(null);
    this.ngbModal.open(content, {windowClass: 'modal-holder', centered: true, size: size});
  }
  validateFileType(type) {
    if (type === 'image/png' || type === 'image/jpg' || type === 'image/jpeg') {
      return true;
    } else {
      this.toastr.error('لطفا عکس با فرمت صحیح را انتخاب نمایید');
      return false;
    }
  }
  fileChangeEvent(event: any) {
    if (this.validateFileType(event.target.files[0].type)) {
      this.ngbModal.open(this.imageModal);
      this.imageChangedEvent = event;
    }


  }



  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.compressFile(this.croppedImage, 'name', this.key);

  }

  imageLoaded() {
    // show cropper
  }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  compressFile(image, fileName, elementKey) {
    let orientation = -1;
    this.imgResultBeforeCompress = image;


    this.sizeOfOriginalImage = this.imageCompress.byteCount(image) / (1024 * 1024);
    // console.warn('Size in bytes is now:', this.sizeOfOriginalImage);

    this.imageCompress.compressFile(image, orientation, 50, 90).then(
      result => {
        document.getElementById(elementKey + `Content`).innerHTML = '';
        const img = document.createElement('img');
        if (elementKey === 'profileImage,') {
          img.setAttribute('style', 'object-fit:cover;max-width: 100%;;border-radius: 7px;width:auto;height:auto');
        } else {
          img.setAttribute('style', 'object-fit:cover;max-width: 100%;;border-radius: 7px;width:auto;height:205px');
        }

        img.src = result;
        document.getElementById(elementKey + `Content`).append(img);
        document.getElementById(elementKey + `Box`).style.display = 'none';
        document.getElementById(elementKey + `Del`).style.display = 'block';
        this.imgResultAfterCompress = result;
        this.localCompressedURl = result;
        this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024);
        // console.warn('Size in bytes after compression:', this.sizeOFCompressedImage);
        if (elementKey === `profileImage`) {
          this.profileImage = result;
        } else if (elementKey === `lisence`) {
          this.lisence = result;
        } else {
          this.nationalCard = result;
        }
// create file from byte
        const imageName = fileName;
// call method that creates a blob from dataUri
        const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
// imageFile created below is the new compressed file which can be send to API in form data
        const imageFile = new File([result], imageName, {type: 'image/jpeg'});
        // console.log(result);
      });
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], {type: 'image/jpeg'});
    return blob;
  }


}
